import { gql } from '@apollo/client';

const SEARCH_WAREHOUSE_IN = gql`
  query SearchWarehouseIn($limit: Int, $offset: Int, $searchText: String) {
    searchWarehouseIn(limit: $limit, offset: $offset, searchText: $searchText ) {
      code
      success
      message
      count
      results {
        Id
        JobNumber
        Customer {
          Id
          Code
          Name
        }
        CustomerReference
        SupplierReference
        ShipperReference
        ConsigneeReference
        CarrierReference
      }
    }
  }
`;

export default SEARCH_WAREHOUSE_IN;
